<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas :notificacaoSocket="alertaSocket" :texto="alerta.texto" :tipo="alerta.tipo"></Alertas>

    <DataTable
      v-show="showSkeletonTable == false"
      :tableTitle="'Logs Sistema'"
      :tableHeader="headers"
      :tableRows="listaDeLogs"
      :isEdit="false"
      :isDel="false"
      :isFinish="false"
      :isPrint="false"
      :totalItens="total"
      v-on:datatable-update-page="updatePage"
      v-on:datatable-update-search="updateSearch"
    ></DataTable>

    <SkeletonTable
      v-show="showSkeletonTable == true"
      :showSkeletonTable="showSkeletonTable"
    ></SkeletonTable>
    
  </v-col>
</template>

<script>
import store from "@/store/index";
import axios from "../plugins/axios";
import DataTable from "@/components/DataTable2.vue";
import SkeletonTable from "../components/SkeletonTable";
import Alertas from "../components/Alertas.vue";

export default {
  components: {
    DataTable,
    SkeletonTable,
    Alertas,
  },

  sockets: {
    reciveInsertLog: function () {
      this.alertaSocket.texto = 'Novo log gerado!'
      this.alertaSocket.tipo = 'info'
      this.inicializar();
    },
  },

  data: () => ({
    //Paginação 
    page: 1,
    search: null,
    total: null,
    //Fim da paginação

    rules: {
      requerido: (value) => value != null || "Requer o campo!",
    },

    alerta: {
      texto: "",
      tipo: ""
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaModal: {
      texto: "",
      tipo: "",
    },

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    showSkeletonTable: true,

    headers: [
      {
        text: "ID",
        value: "logSistema.numeroLogSistema",
      },
      {
        text: "Status Log",
        value: "logSistema.indicadorTipoLog",
      },
      {
        text: "Nome Model",
        value: "logSistema.numeroModel",
      },
      {
        text: "Nome Função",
        value: "logSistema.nomeFuncaoLog",
      },
      {
        text: "Nome Usuario",
        value: "usuario.nomeUsuario",
      },
      {
        text: "Decrição Log",
        value: "logSistema.descricaoLog",
      },
      {
        text: "Data Criação",
        value: "logSistema.dataCriacaoLog",
      },
      // { text: "Ações", value: "actions", sortable: false },
    ],

    listaDeLogs: [],

  }),

  created() {
    this.showSkeletonTable = true
    this.inicializar();
  },

  methods: {
    async inicializar() {
      try {
        const response = await axios.put('logSistema', {page: this.page, search: this.search}, this.config)
        
        if(!response.data || response.data.length > 0) {
          this.listaDeLogs = response.data;
          this.total = response.data[0].logSistema.total
        }

      } catch (error) {
        console.log(error)
        this.alerta.texto = error.response.data.message
        this.alerta.tipo = 'erro';
      } finally {
        this.showSkeletonTable = false
      }
    },

    async updateSearch(search) {
      if(search){
        this.search = search
        this.page = 1
        await this.inicializar()
      } else {
        this.page = 1
      }
    },

    async updatePage(pagination) {
      this.page = pagination.page
      await this.inicializar()
    },
    
  },
};
</script>
